/**
 * 雇用形態設定ページ用のスクリプト
 */
 if (is_route('freon.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        freon_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.freon_event_set = function() {

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['vehicle_id', 'holding_id']);
        return false;
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal][data-vehicle_id=' + results.vehicle_id + ']').trigger('click');
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['ids[]']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        const vehicleId = $('#freon-detail-modal .modal-body').data('vehicle_id');
        _modal.submit(this, 'delete-modal', function() {
            if (vehicleId) {
                $('[data-detail-modal][data-vehicle_id=' + vehicleId + ']').trigger('click');
            }
        });
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#freon-all-delete', function () {
        $(".freon-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.freon-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#freon-all-delete, .freon-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#freon-multi-delete-button').prop('disabled', ($('.freon-delete:checked').length == 0));
    });

    // 一括削除確認時
    $(document).on('click', '[data-all-confirm-modal]', function () {
        var ids =  [];
        if ($(this).data('id') == null) {
            $('.freon-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'all-confirm-modal', {'ids': ids});
        }
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#freon-csv-setting-modal-csv-submit-message').addClass('display-none');
        $('#freon-csv-setting-modal-csv-submit-message').empty();
        $('#freon-csv-setting-modal-csv-error').addClass('display-none');
        $('#freon-csv-setting-modal-csv-error').empty();
        $('#freon-csv-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#freon-csv-setting-modal-csv', function () {
        let modalId = '#freon-csv-setting-modal';
        let formId = '#freon-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#freon-csv-setting-modal-csv').val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#freon-csv-setting-modal';
        let formId = '#freon-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}